// lodash
import unionBy from 'lodash/unionBy';

const unionWithDevFeatures = (bffFeatures) => {
  const devFeatures = window.env.FEATURES || [];
  return unionBy(devFeatures, bffFeatures, 'id').map(feature => ({
    ...feature,
    enabled: Boolean(
      feature.enabled === true ||
      feature.enabled === 1 ||
      feature.enabled === 'true' ||
      feature.enabled === '1',
    ),
  }));
};

export default unionWithDevFeatures;
